<template>
  <div class="game-score">
    <svg class="game-score__circle" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 90 90">
      <path class="circle__shadow" fill="#000" d="M11.7,15.1C-5.7,38.4-2.7,64.9,14,77.4s48.8,17.5,63.4,0S95.3,20.3,63.9,4.6
        C58.2,1.7,29.1-8.3,11.7,15.1z"/>
      <path fill="#D84D3E" stroke="#000" stroke-width="1.5" stroke-miterlimit="10" d="M11.7,15.1C-5.7,38.4-2.7,64.9,14,77.4s48.8,17.5,63.4,0S95.3,20.3,63.9,4.6
        C58.2,1.7,29.1-8.3,11.7,15.1z"/>
    </svg>

    <p class="game-score__text" v-html="`${$store.state.score} m`"/>
  </div>
</template>

<script>
export default {
  name: 'GameLife',
};
</script>

<style lang="scss" scoped>
.game-score {
  position: relative;

  &__circle {
    width: 65px;
    height: 65px;

    overflow: visible;

    .circle__shadow {
      transform: translate(-8px, 8px);
    }
  }

  &__text {
    position: absolute;
    top: 48%;
    left: 50%;
    margin-top: 2px;

    font-size: 16px;
    transform: translate(-50%, -50%);

    white-space: nowrap;
  }

  @include mq($until: mobileL) {
    &__text {
      margin-top: 1px;

      font-size: 11px;
      font-weight: bold;
    }
  }
}
</style>
